module.exports = __webpack_public_path__ + "img/part6-icon2-over.1caae00e.png";